import { trigger, transition, style, query, group, animateChild, animate, stagger } from '@angular/animations';

export const routeAnimations =
trigger('routeAnimations', [
  transition('Default <=> *', [
    style({ position: 'fixed', width: '100%' }),
    query(':enter, :leave', [
      style({
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%'
      })
    ], { optional: true }),
    query(':enter', [
      style({ opacity: 0 })
    ], { optional: true }),
    query(':leave', animateChild(), { optional: true }),
    group([
      query(':leave', [
        animate('300ms ease-in-out', style({ left: '0%', opacity: 0 }))
      ], { optional: true }),
      query(':enter', [
        animate('300ms ease-in-out', style({ left: '0%', opacity: 1 }))
      ], { optional: true })
    ]),
    query(':enter', animateChild(), { optional: true }),
  ]),
  transition('SlideInRight <=> *', [
    style({ position: 'fixed', width: '100%' }),
    query(':enter, :leave', [
      style({
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%'
      })
    ], { optional: true }),
    query(':enter', [
      style({ left: '100%'})
    ], { optional: true }),
    query(':leave', animateChild(), { optional: true }),
    group([
      query(':leave', [
        animate('300ms ease-in-out', style({ left: '-100%'}))
      ], { optional: true }),
      query(':enter', [
        animate('300ms ease-in-out', style({ left: '0%'}))
      ], { optional: true })
    ]),
    query(':enter', animateChild(), { optional: true }),
  ]),
  transition('FadeIn <=> *', [
    style({ position: 'fixed', width: '100%' }),
    query(':enter', [
      style({
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%'
      })
    ], { optional: true }),
    query(':enter', [
      style({ opacity: 0 })
    ], { optional: true }),
    group([
      query(':enter', [
        animate('300ms ease-in-out', style({ left: '0%', opacity: 1 }))
      ], { optional: true })
    ]),
    query(':enter', animateChild(), { optional: true }),
  ])
]);